function clearSessionStorage() {
    return new Promise((resolve, reject) => {
        try {
            sessionStorage.clear();
            resolve('Session storage cleared');
        } catch (error) {
            reject('Failed to clear session storage');
        }
    });
};

function getSessionStorageItem(key) {
    return new Promise((resolve, reject) => {
        try {
            const value = sessionStorage.getItem(key);
            if (value !== null) {
                resolve(value);
            } else {
                reject(`No item found in session storage for key: ${key}`);
            }
        } catch (error) {
            reject(`Failed to retrieve item from session storage: ${error}`);
        }
    });
};

function setSessionStorageItem(key, value) {
    return new Promise((resolve, reject) => {
        try {
            sessionStorage.setItem(key, value);
            resolve("Success");
        } catch (error) {
            reject(`Failed to retrieve item from session storage: ${error}`);
        }
    });
};

export const sessionServices = { clearSessionStorage, getSessionStorageItem, setSessionStorageItem }